import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchWebtools,
  fetchWebtoolsFavorites,
  addToFavorite,
  fetchWebtoolsCategories
} from "Thunks";
import {
  reduceWebtools,
  clickPlus,
  clickMinus,
  addToWebtools,
  setFilterCategory,
  addToFavoritesReducer,
  removeFromFavoritesReducer,
  setFilterSearch,
  filterWebtools,
  setFetching
} from "Actions";
import styles from "./Webtool.local.scss";

import WebtoolComponent from "./WebtoolComponent";

class WebtoolContainer extends Component {
  componentDidMount() {
    const {
      fetchWebtools,
      fetchWebtoolsFavorites,
      fetchWebtoolsCategories
    } = this.props;
    fetchWebtools({});
    fetchWebtoolsFavorites({ limit: 30 });
    fetchWebtoolsCategories();
  }

  componentDidUpdate(prevProps) {
    const { favorites, reduceWebtools } = this.props;

    if (favorites !== prevProps.favorites) {
      reduceWebtools(favorites);
    }
  }

  handleClickPlus = () => {
    this.props.clickPlus();
  };
  handleClickMinus = () => {
    this.props.clickMinus();
  };

  handleSetFav = (webtool, e) => {
    const {
      addToFavorite,
      addToFavoritesReducer,
      removeFromFavoritesReducer,
      addToWebtools
    } = this.props;

    let current = e.currentTarget.classList;

    if (!current.contains(styles.activated)) {
      return false;
    }
    e.preventDefault();
    addToFavorite({ id: webtool.id, objectType: "WEBTOOL" }).then(resp => {
      if (current.contains(styles.favorite)) {
        removeFromFavoritesReducer(webtool);
        addToWebtools(webtool);
      } else {
        addToFavoritesReducer(webtool);
      }
    });
    return false;
  };

  handleApplyCategory = (categoryId, e) => {
    let current = e.currentTarget;
    if (current.classList.contains(styles.activated)) {
      return null;
    }

    const {
      //fetchLatestWebtools,
      //fetchFavorites,
      setFilterCategory,
      filterWebtools,
      setFetching
    } = this.props;

    setFetching(true);

    setFilterCategory(categoryId === 0 ? null : categoryId);
    setTimeout(() => {
      filterWebtools(this.props.filter);
      setFetching(false);
    }, 100);
    //initWebtoolsList();
    //fetchLatestWebtools({});
    //fetchFavorites({});
  };

  handleSearchWebtool = e => {
    const { setFilterSearch, filterWebtools, setFetching, lng } = this.props;
    const { value } = e.currentTarget;
    setFetching(true);

    setFilterSearch(value, lng);
    setTimeout(() => {
      filterWebtools(this.props.filter);
      setFetching(false);
    }, 10);
  };

  render() {
    const {
      webtools,
      fetching,
      fetched,
      favorites,
      fetchingFav,
      fetchedFav,
      categories,
      fetchingCat,
      fetchedCat,
      lng,
      plusActivated,
      minusActivated,
      filter
    } = this.props;
    return (
      <WebtoolComponent
        lng={lng}
        fetching={fetching}
        fetched={fetched}
        filter={filter}
        webtools={webtools}
        fetchingFav={fetchingFav}
        fetchedFav={fetchedFav}
        favorites={favorites}
        categories={categories}
        fetchingCat={fetchingCat}
        fetchedCat={fetchedCat}
        plusActivated={plusActivated}
        minusActivated={minusActivated}
        setFav={this.handleSetFav}
        clickPlus={this.handleClickPlus}
        clickMinus={this.handleClickMinus}
        applyCategory={this.handleApplyCategory}
        searchWebtool={this.handleSearchWebtool}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  webtools: state.webtools.list.items,
  fetching: state.webtools.list.fetching,
  fetched: state.webtools.list.fetched,
  favorites: state.webtools.favorites.items,
  fetchingFav: state.webtools.favorites.fetching,
  fetchedFav: state.webtools.favorites.fetched,
  categories: state.webtools.categories.items,
  fetchingCat: state.webtools.categories.fetching,
  fetchedCat: state.webtools.categories.fetched,
  filter: state.webtools.filter,
  lng: state.params.lng,
  plusActivated: state.webtools.favorites.plusActivated,
  minusActivated: state.webtools.favorites.minusActivated
});

const mapDispatchToProps = dispatch => ({
  fetchWebtools: type => dispatch(fetchWebtools(type)),
  fetchWebtoolsFavorites: data => dispatch(fetchWebtoolsFavorites(data)),
  fetchWebtoolsCategories: () => dispatch(fetchWebtoolsCategories()),
  reduceWebtools: favorites => dispatch(reduceWebtools(favorites)),
  clickPlus: () => dispatch(clickPlus()),
  clickMinus: () => dispatch(clickMinus()),
  setFilterCategory: categoryId => dispatch(setFilterCategory(categoryId)),
  addToFavorite: data => dispatch(addToFavorite(data)),
  addToWebtools: favorite => dispatch(addToWebtools(favorite)),
  addToFavoritesReducer: favorite => dispatch(addToFavoritesReducer(favorite)),
  setFilterSearch: (word, lng) => dispatch(setFilterSearch(word, lng)),
  filterWebtools: filter => dispatch(filterWebtools(filter)),
  setFetching: fetching => dispatch(setFetching(fetching)),
  removeFromFavoritesReducer: favorite =>
    dispatch(removeFromFavoritesReducer(favorite))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WebtoolContainer);



// WEBPACK FOOTER //
// ./src/components/Community/Common/Webtool/WebtoolContainer.js